import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

const Slider = React.forwardRef(({ className, gradientLine = true, ...props }, ref) => (
    <SliderPrimitive.Root
        ref={ref}
        className={cn(
            "relative flex w-full touch-none select-none items-center",
            className
        )}
        {...props}
    >
        <SliderPrimitive.Track
            className="relative h-2 w-full grow overflow-hidden rounded-full bg-secondary/50"
        >
            <SliderPrimitive.Range className={cn("absolute h-full", gradientLine ? "bg-gradient-to-r from-amber-600 to-amber-700" : "bg-primary")} />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb
            className="block h-5 w-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:scale-110 hover:border-amber-600 cursor-pointer shadow-md"
        />
    </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
